import { createContext, useContext, useState } from 'react';

interface CartContextCtx {
  isCartOpen: boolean;
  setIsCartOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const CartContext = createContext({} as CartContextCtx);

export const CartProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [isCartOpen, setIsCartOpen] = useState(false);

  return (
    <CartContext.Provider
      value={{
        isCartOpen,
        setIsCartOpen,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);

  if (!context) {
    throw new Error('useCart hook must be used under CartProvider');
  }

  return context;
};
